export const timeline = [
  {
    span: "1990s",
    label: "1990 — 1999",
    count: 26,
    note: "卡带、录像厅和第一部国产偶像剧。",
    highlight: "1998 · 一句台词被记了二十多年",
  },
  {
    span: "2000s",
    label: "2000 — 2009",
    count: 54,
    note: "选秀元年、论坛时代、博客的黄金期。",
    highlight: "2005 · 一盘没寄出去的 demo",
  },
  {
    span: "2010s",
    label: "2010 — 2019",
    count: 61,
    note: "直播综艺崛起，短视频改写了传播方式。",
    highlight: "2013 · 没被剪掉的三分钟",
  },
  {
    span: "2020s",
    label: "2020 — 至今",
    count: 18,
    note: "当年的新人成了前辈，旧料开始被系统重看。",
    highlight: "2026 · 十五年前的那首歌被重新听见",
  },
];

export const siteStats = [
  { value: "199", label: "已归档条目", unit: "条" },
  { value: "4", label: "年代区间", unit: "个" },
  { value: "27", label: "持续整理", unit: "年" },
  { value: "12", label: "每周更新", unit: "篇" },
];